import { render, staticRenderFns } from "./word_cloud.vue?vue&type=template&id=2daff654&scoped=true&"
import script from "./word_cloud.vue?vue&type=script&lang=js&"
export * from "./word_cloud.vue?vue&type=script&lang=js&"
import style0 from "./word_cloud.vue?vue&type=style&index=0&id=2daff654&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2daff654",
  null
  
)

export default component.exports